// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10VSf","colBig":"styles_colBig__35FwF","colSmall":"styles_colSmall__79Xpf"};